import React from "react";
import BannerProjects from "../../components/bannerProjects";
import Diferenciais from "../../components/diferenciais";
import RevertemosProblemas from "../../components/revertemosProblemas";
import Rodape from "../../components/rodape";
import ResgatamosProjetos from "../../components/resgatamosProjetos";

export default function RecuperacaoProjetos() {
    return (
        <>
            <BannerProjects
                backgroundImage="../assets/banner-recuperacao-projetos.png"
                title="/RECUPERAÇÃO"
                titleBold="DE PROJETOS"
                iconSrc="../assets/icone-projectiva-behub.png"
                iconAlt="Projectiva BeHub"
                iconText="be."
                iconTextBold="hub"
                descriptionBold=""
                description="Agimos com rapidez e precisão para identificar falhas, realinhar objetivos e recolocar os projetos no caminho do sucesso."
                footerText="VERTICAL PROJECTS | Development"
                buttonText="Quero me conectar"
                buttonColor="from-[#4B3BDB] to-[#A002CB]"
                brand="behub"
            />
            <ResgatamosProjetos />
            <Diferenciais
                servicosData={[
                    {
                        icon: "../assets/servicos/diagnostico_icon.svg",
                        iconHover: "../assets/servicos/diagnostico_icon.svg",
                        title: "DIAGNÓSTICO E AÇÕES RÁPIDAS",
                        text: (
                            <>
                                Identificamos rapidamente os problemas
                                essenciais e elaboramos um plano de recuperação
                                eficaz, garantindo que o projeto retome o
                                caminho certo.
                            </>
                        ),
                        glowColor: "#A800E4",
                        url: "",
                    },
                    {
                        icon: "../assets/servicos/suporte_icon.svg",
                        iconHover: "../assets/servicos/suporte_icon.svg",
                        title: "EXPERTISE",
                        text: (
                            <>
                                Nossa equipe combina conhecimento técnico e
                                estratégia de negócios para solucionar problemas
                                complexos e realinhar o projeto aos objetivos de
                                negócio.
                            </>
                        ),
                        glowColor: "#A800E4",
                        url: "",
                    },
                    {
                        icon: "../assets/servicos/reducao_icon.svg",
                        iconHover: "../assets/servicos/reducao_icon.svg",
                        title: "REDUÇÃO DE CUSTOS",
                        text: (
                            <>
                                Maximizamos o aproveitamento dos recursos
                                investidos, reduzindo custos e eliminando
                                desperdícios, garantindo o melhor uso do que já
                                foi desenvolvido.
                            </>
                        ),
                        glowColor: "#A800E4",
                        url: "",
                    },
                    {
                        icon: "../assets/servicos/mitigacao_icon.svg",
                        iconHover: "../assets/servicos/mitigacao_icon.svg",
                        title: "MITIGAÇÃO",
                        text: (
                            <>
                                Identificamos e mitigamos os riscos potenciais,
                                preservando o projeto de contratempos e
                                assegurando sua conclusão com sucesso.
                            </>
                        ),
                        glowColor: "#A800E4",
                        url: "",
                    },
                    {
                        icon: "../assets/servicos/eficiencia_icon.svg",
                        iconHover: "../assets/servicos/eficiencia_icon.svg",
                        title: "EFICIÊNCIA OPERACIONAL",
                        text: (
                            <>
                                Otimizamos os processos internos para eliminar
                                ineficiências, acelerando as entregas e elevando
                                a qualidade.
                            </>
                        ),
                        glowColor: "#A800E4",
                        url: "",
                    },
                    {
                        icon: "../assets/servicos/suporte_icon.svg",
                        iconHover: "../assets/servicos/suporte_icon.svg",
                        title: "SUPORTE CONTÍNUO",
                        text: (
                            <>
                                Asseguramos apoio após a recuperação, garantindo
                                que as melhorias sejam sustentáveis a longo
                                prazo.
                            </>
                        ),
                        glowColor: "#A800E4",
                        url: "",
                    },
                ]}
                title={<>
                    <span className="font-inter-bold">Benefícios</span>
                </>}
            />
            <RevertemosProblemas />
            <Rodape />
        </>
    );
}
